import {Breakpoints, styled} from '@vw-marketing/us-components';

export const StyledContent = styled.div`
  padding-right: 15px;

  @media (min-width: ${Breakpoints.b1280}px) {
    padding: 0 20px 0 17px;
  }
`;

export const StyledButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 22px;
  max-height: 44px;
  column-gap: 20px;
  button:focus {
    outline: none;
  }
`;
